import Snackbar from '@mui/material/Snackbar';
import { SnackbarContent } from '@mui/material';
import { green, red } from '@mui/material/colors';

const ToastNotification = ({ toastConfig, toastState, toastMessage, handleClose }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: toastConfig.vertical, horizontal: toastConfig.horizontal }}
            open={toastConfig.open}
            onClose={handleClose}
            key={toastConfig.vertical + toastConfig.horizontal}
            autoHideDuration={3000}
        >
            {toastState === "success" ? (
                <SnackbarContent
                    message={toastMessage}
                    sx={{
                        backgroundColor: green[600],
                        color: 'white',
                        padding: '10px 18px',
                        borderRadius: "42px"
                    }}
                />
            ) : (
                <SnackbarContent
                    message={toastMessage}
                    sx={{
                        backgroundColor: red[600],
                        color: 'white',
                        padding: '10px 18px',
                        borderRadius: "42px"
                    }}
                />
            )}
        </Snackbar>
    )
}

export default ToastNotification;